import { render, staticRenderFns } from "./Hotspot.vue?vue&type=template&id=3dafd648&scoped=true"
import script from "./Hotspot.vue?vue&type=script&lang=js"
export * from "./Hotspot.vue?vue&type=script&lang=js"
import style0 from "./Hotspot.vue?vue&type=style&index=0&id=3dafd648&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dafd648",
  null
  
)

export default component.exports